import { styled } from "@mui/system";
import { Box } from "@mui/material";

export const HeadlinePostInputButton = styled(Box)({
    display: "flex",
    cursor: "pointer",
    flexDirection: "row",
    alignItems: "center",
    gap: "8px",
    width: "max-content",
    height: "32px",
    borderRadius: "90px",
    padding: "0 12px",
    backgroundColor: "var(--community-color-transparent-black-05)",
    "& > svg": {
        width: "16px",
        height: "16px",
    },
    "& > p": {
        fontSize: "14px",
        fontWeight: "500",
        color: "var(--community-color-primary-text)",
    },
});

export const PostsFeedTitle = styled(Box)({
    margin: "16px 0",
});
